<script setup async lang="ts">
const { GenerateTags } = useSEO()

GenerateTags({
  title: '💪 Champs! 📈',
  desc: 'Crappy Stats of OTB\'s Crappy Quiz',
})
</script>

<template>
  <div>
    <TheTopThree />
  </div>
</template>
